export const HIGHLIGHTED_CLASS_NAME = 'pdf-viewer-highlighted-element';
